import { render, staticRenderFns } from "./btm.vue?vue&type=template&id=57ac9f56&scoped=true&"
import script from "./btm.vue?vue&type=script&lang=js&"
export * from "./btm.vue?vue&type=script&lang=js&"
import style0 from "./btm.vue?vue&type=style&index=0&id=57ac9f56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ac9f56",
  null
  
)

export default component.exports